import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation } from '@tanstack/react-query';

import Api from '@/services/api';
import { BaseContext } from '@/types';
import { RosaReport } from '@/types/entities/Rosa';

export type UpdateCommentRequest = BaseContext & {
	comment: string;
	report_id: string;
};

type UpdateCommentResponse = RosaReport;

async function updateComment(payload: UpdateCommentRequest): Promise<UpdateCommentResponse> {
	const url = `ergonomic-tool/rosa/comment/${payload.report_id}`;
	const { data } = await Api.put<any>(url, payload);
	return data;
}

export const useUpdateComment = () => {
	return useMutation((body: UpdateCommentRequest) => updateComment(body), {
		onSuccess: () => {
			message.success(I18n.get('Rosa report updated successfully!'));
		},
		onError: () => {
			message.error(I18n.get('Fail to save the comments'));
		}
	});
};
